import { RecipientOfficeCategory } from '../generated/enums.gen';

export const RECIPIENT_OFFICE_CATEGORY_LABELS: Readonly<Record<RecipientOfficeCategory, string>> = {
  [RecipientOfficeCategory.Gubernatorial]: 'Governor',
  [RecipientOfficeCategory.Legislative]: 'State Senate or Assembly',
  [RecipientOfficeCategory.Other]: 'Any other office',
};

export function recipientOfficeCategoryLabel(category: RecipientOfficeCategory): string {
  return RECIPIENT_OFFICE_CATEGORY_LABELS[category];
}
